const KEY_TOKEN = "session.token";

interface Item<T = string> {
  set: (value: T) => void;
  get: () => T;
  has: () => boolean;
  remove: VoidFunction;
}

const persist = (key: string): Item => {
  const set = (value: string) => localStorage.setItem(key, value);
  const get = (): string => localStorage.getItem(key) || "";
  const has = () => get() !== "";
  const remove = () => localStorage.removeItem(key);

  return {
    set,
    get,
    has,
    remove,
  };
};

export const Token = persist(KEY_TOKEN);
